<template>
  <div class="wrapper">
    <div class="content">
      The appointment booking page is currently not available.
    </div>
  </div>
</template>

<script>

export default {
  name: 'ConnectionErrorPage',
  mounted () {
    document.title = 'Error'
  }
}
</script>

<style scoped lang="scss">

.wrapper {
  /*border: 2px solid;
  border-color: var(--primary-border-color) !important;*/
  color: red !important;
  font-size: 32px !important;
}

</style>
